<template>
  <pf-description-list
    v-if="cashbackAvailable && cashbackState.state === 'success'"
    horizontal
    class="payment-totals"
    term-width="30ch"
    style="max-width: 80ch"
  >
    <pf-description-list-group>
      <pf-description-list-term>
        <pf-tooltip>
          {{ $t('Cashback disponibile') }}: {{ ' ' }} <help-icon />

          <template #content>
            {{ $t('Cashback totale a disposizione {0}', [$currency(ammontareCashbackAzienda, currency)]) }}
          </template>
        </pf-tooltip>
      </pf-description-list-term>
      <pf-description-list-description ouia-id="cashback-value" class="pf-v6-u-text-align-end">
        {{ $currency(-maxCashback, currency) }} <span class="vat">({{$t('IVA inclusa')}})</span>
      </pf-description-list-description>
    </pf-description-list-group>

    <pf-description-list-group>
      <pf-description-list-term>
        <pf-checkbox v-model="useCashBack" name="use_cashback" :label="$t('Utilizza il cashback')" ouia-id="cashback-checkbox" @update:model-value="change" />
        <input v-if="useCashBack" type="hidden" :value="maxCashback" name="cashback_amount" />
      </pf-description-list-term>
    </pf-description-list-group>

    <pf-description-list-group>
      <pf-description-list-term><strong>{{ $t('Totale prima fattura') }}:</strong></pf-description-list-term>
      <pf-description-list-description class="pf-v6-u-text-align-end" ouia-id="total-invoice-with-cashback">
        <strong>{{ $currency(grandTotal, currency) }}</strong> <span class="vat">({{$t('IVA inclusa')}})</span>
      </pf-description-list-description>
    </pf-description-list-group>
  </pf-description-list>

  <pf-empty-state v-else-if="cashbackState.state !== 'success'">
    <pf-empty-state-header title="Verifica conto Artera" heading-level="h4">
      <template #icon>
        <pf-empty-state-icon>
          <pf-spinner />
        </pf-empty-state-icon>
      </template>
    </pf-empty-state-header>
  </pf-empty-state>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { useLoginStore } from '@/store/login';
import { CashbackResource } from '@/resources';
import { asyncComputed } from '@common/asyncComputed';
import { $t as _t } from '@/i18n';
import HelpIcon from '@vue-patternfly/icons/help-icon';

const { result: ammontareCashbackAzienda, state: cashbackState } = asyncComputed(async() => {
  if (!login.is_reseller) {
    return 0;
  }
  const cashback = await new CashbackResource().get(1);
  return cashback.amount;
});

const props = defineProps<{
  modelValue: number;
  totaleOffertaIvato: number;
  currency: 'CHF' | 'EUR';
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): void
}>();

const login = useLoginStore();
const useCashBack = ref(true);

const cashbackAvailable = computed(() => login.is_reseller && ammontareCashbackAzienda.value > 0);

const maxCashback = computed(() =>  {
  return Math.min(props.totaleOffertaIvato, ammontareCashbackAzienda.value);
});

const grandTotal = computed(() => props.totaleOffertaIvato - (useCashBack.value ? maxCashback.value : 0));

// Emetti il valore quando cambia useCashBack
function change(newValue: boolean) {
  emit('update:modelValue', newValue ? maxCashback.value : 0);
}
</script>
